import React, { useState } from "react";
import "./ServiceLocations.css";

export function ServiceLocations() {
  const locations = {
    BIHAR: [
      "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur",
      "Bhojpur", "Buxar", "Darbhanga", "East Champaran (Motihari)", "Gaya",
      "Gopalganj", "Jamui", "Jehanabad", "Kaimur (Bhabua)", "Katihar",
      "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani",
      "Munger (Monghyr)", "Muzaffarpur", "Nalanda", "Nawada", "Patna",
      "Purnia (Purnea)", "Rohtas (Sasaram)", "Saharsa", "Samastipur",
      "Saran (Chapra)", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan",
      "Supaul", "Vaishali (Hajipur)", "West Champaran (Bettiah)"
    ],
    JHARKHAND: [
      "Hatia", "Bokaro", "Chatra", "Deoghar", "Dhanbad", "Dumka",
      "East Singhbhum (Jamshedpur)", "Garhwa", "Giridih", "Godda", "Gumla",
      "Hazaribagh", "Jamtara", "Khunti", "Koderma", "Latehar", "Lohardaga",
      "Pakur", "Palamu", "Ramgarh", "Ranchi", "Sahebganj",
      "Seraikela Kharsawan", "Simdega", "West Singhbhum (Chaibasa)"
    ],
    UP: [
      "Agra", "Aligarh", "Ambedkar Nagar", "Amethi", "Amroha (J.P. Nagar)",
      "Auraiya", "Ayodhya (Faizabad)", "Azamgarh", "Baghpat", "Bahraich",
      "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti",
      "Bhadohi (Sant Ravidas Nagar)", "Bijnor", "Budaun", "Bulandshahr",
      "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Farrukhabad",
      "Fatehpur", "Firozabad", "Gautam Buddha Nagar (Noida)", "Ghaziabad",
      "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hapur (Panchsheel Nagar)",
      "Hardoi", "Hathras (Mahamaya Nagar)", "Jalaun", "Jaunpur", "Jhansi",
      "Kannauj", "Kanpur Dehat", "Kanpur Nagar", "Kasganj (Kanshiram Nagar)",
      "Kaushambi", "Kheri (Lakhimpur Kheri)", "Kushinagar (Padrauna)",
      "Lalitpur", "Lucknow", "Maharajganj", "Mahoba", "Mainpuri", "Mathura",
      "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Pilibhit",
      "Pratapgarh", "Prayagraj (Allahabad)", "Raebareli", "Rampur",
      "Saharanpur", "Sambhal (Bhim Nagar)", "Sant Kabir Nagar",
      "Shahjahanpur", "Shamli (Prabuddh Nagar)", "Shravasti",
      "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"
    ],
    DELHI: [
      "Central Delhi", "East Delhi", "New Delhi", "North Delhi",
      "North East Delhi", "North West Delhi", "Shahdara", "South Delhi",
      "South East Delhi", "South West Delhi", "West Delhi", "Gurugram"
    ],
    OTHER: ["Delhi NCR", "Kolkata", "Mumbai", "Madhya Pradesh", "Chennai", "Bangalore"]
  };

  const [search, setSearch] = useState("");
  const [selectedState, setSelectedState] = useState("ALL");

  const isSearching = search.trim() !== "";

  const filteredLocations = Object.entries(locations).reduce(
    (result, [state, cities]) => {
      // Respect active tab selection, unless the user is actively searching
      if (!isSearching && selectedState !== "ALL" && state !== selectedState) {
        return result;
      }
      const filteredCities = cities.filter((city) =>
        city.toLowerCase().includes(search.toLowerCase())
      );
      if (filteredCities.length > 0) {
        result[state] = filteredCities;
      }
      return result;
    },
    {}
  );

  return (
    <div className="service-locations">
      <h2>Our Service Locations</h2>
      
      <input
        type="text"
        className="search-bar"
        placeholder="Search for your city..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="state-tabs">
        {["ALL", "BIHAR", "JHARKHAND", "UP", "DELHI", "OTHER"].map((state) => (
          <button
            key={state}
            className={`state-tab-btn ${selectedState === state ? "active" : ""}`}
            onClick={() => setSelectedState(state)}
          >
            {state === "ALL"
              ? "All Locations"
              : state === "UP"
              ? "Uttar Pradesh"
              : state}
          </button>
        ))}
      </div>

      <div className="locations-grid">
        {Object.entries(filteredLocations).map(([state, cities]) => (
          <React.Fragment key={state}>
            <h3 className="state-title">{state === "UP" ? "UTTAR PRADESH" : state}</h3>
            <div className="city-cards">
              {cities.map((city, index) => (
                <div className="city-card" key={index}>
                  <p className="city-name">{city}</p>
                  <a href="tel:9625581855" className="call-button">
                    Call
                  </a>
                </div>
              ))}
            </div>
          </React.Fragment>
        ))}
        {Object.keys(filteredLocations).length === 0 && (
          <p className="no-result">No locations found matching your search.</p>
        )}
      </div>
    </div>
  );
}